import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';



export default function Review({classes,parent_details:{course,
phase,
stream,
class:classs,
commencement_date
},
medium_list,
admission_mode_list
}) {


  return (
    <React.Fragment>

      <List disablePadding>

      <ListItem className={classes.listItem} >
        <ListItemText  >
  <Typography variant="subtitle2">Stream</Typography>
        </ListItemText>
        <Typography variant="body2">{stream}</Typography>
      </ListItem>
      <ListItem className={classes.listItem} >
      <ListItemText  >
<Typography variant="subtitle2">Class</Typography>
      </ListItemText>
        <Typography variant="body2">{classs}</Typography>
      </ListItem>
          <ListItem className={classes.listItem} >
          <ListItemText  >
    <Typography variant="subtitle2">Course</Typography>
          </ListItemText>
            <Typography variant="body2">{course}</Typography>
          </ListItem>

          <ListItem className={classes.listItem} >
          <ListItemText  >
    <Typography variant="subtitle2">Phase</Typography>
          </ListItemText>
            <Typography variant="body2">{phase}</Typography>
          </ListItem>
          <ListItem className={classes.listItem} >
          <ListItemText  >
      <Typography variant="subtitle2">Commencement Date</Typography>
          </ListItemText>
            <Typography variant="body2">{commencement_date}</Typography>
          </ListItem>
          {medium_list.length===1 &&
            <ListItem className={classes.listItem} >
            <ListItemText  >
      <Typography variant="subtitle2">Medium</Typography>
            </ListItemText>
              <Typography variant="body2">{medium_list[0].name}</Typography>
            </ListItem>
          }
          {admission_mode_list.length===1 &&
            <ListItem className={classes.listItem} >
            <ListItemText  >
      <Typography variant="subtitle2">Admission Mode</Typography>
            </ListItemText>
              <Typography variant="body2">{admission_mode_list[0].name}</Typography>
            </ListItem>
          }


      </List>


    </React.Fragment>
  );
}
